import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search-with-basis",
  "use": "icon-search-with-basis-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search-with-basis\"><path d=\"m22.5 21.466-5.638-5.664a8.263 8.263 0 1 0-1.06 1.06l5.633 5.638 1.065-1.034ZM3.777 10.526a6.75 6.75 0 1 1 6.75 6.75 6.758 6.758 0 0 1-6.75-6.75Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol